var spotlightsendorspecials = {
	
	init : function(){
		var spotlights_vendor_specials_carousel = $('.spotlights-vendor-specials .spotlights-vendor-specials-carousel').slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
        });
		
		
        spotlights_vendor_specials_carousel.on('afterChange', function(){
			var index = $('.spotlights-vendor-specials .slick-current').data('slick-index');
			console.log(index);
			$('.spotlights-vendor-specials .carousel-pages li.active').removeClass('active');
			$('.spotlights-vendor-specials .carousel-pages li.page-'+index).addClass('active');
        });
        $('.spotlights-vendor-specials .left').click(function(){
            spotlights_vendor_specials_carousel.slick('slickPrev');
            return false;
        });
        $('.spotlights-vendor-specials .right').click(function(){
            spotlights_vendor_specials_carousel.slick('slickNext');
            return false;
        });
		$('.spotlights-vendor-specials .carousel-pages li').click(function(){
			spotlights_vendor_specials_carousel.slick("goTo", $(this).data('index'));
		});
	}	
};


var vendorSpecialsDetails = {

	 init:function(){
		var img_slider = $('.vendor-specials-details .vendor-details-img-slider .img-slider-content .img-slider-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:false,
			dots: false,
			arrows:false,
			nav:false,
		});
		$('.vendor-specials-details .vendor-details-img-slider .img-slider-content .left').click(function(){
			img_slider.slick('slickPrev');
			return false;
		});
		$('.vendor-specials-details .vendor-details-img-slider .img-slider-content .right').click(function(){
			img_slider.slick('slickNext');
			return false;
		});	
	}	
};



